import {observable, action, runInAction} from 'mobx'
import dataFlowLogAPI from '../apis/dataFlowLogAPI'
import alertMessage from '../utils/alertMessage'

export default class DataFlowLogStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable auditLogsList = []
  
  @action
  async auditLogPage(params) {
    this.isFetching = true
    this.auditLogsList = []
    try {
      const response = await dataFlowLogAPI.auditLogPage(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        this.isFetching = false
        if (code === 0) {
          this.approverList = data?.records
        } else {
          alertMessage.error('Failed！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
}
